var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleclockOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FA4B16"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5441_6844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7 14.4625L14.475 13.7125L12.55 11.7721V9.38749H11.525V12.1945L13.7 14.4625ZM12.0018 17.3125C11.2673 17.3125 10.5776 17.1734 9.93275 16.8954C9.288 16.6174 8.72504 16.2379 8.24387 15.7571C7.76279 15.2763 7.38313 14.7137 7.10487 14.0692C6.82662 13.4249 6.6875 12.7356 6.6875 12.0014C6.6875 11.2671 6.82742 10.5771 7.10725 9.93136C7.38717 9.2857 7.76642 8.72357 8.245 8.24499C8.72358 7.7664 9.28533 7.38507 9.93025 7.10099C10.5752 6.81699 11.2651 6.67499 12 6.67499C12.7349 6.67499 13.4248 6.81699 14.0698 7.10099C14.7147 7.38507 15.2764 7.7664 15.755 8.24499C16.2336 8.72357 16.6149 9.28532 16.899 9.93024C17.183 10.5752 17.325 11.2651 17.325 12C17.325 12.7349 17.183 13.4248 16.899 14.0697C16.6149 14.7147 16.2336 15.2764 15.755 15.755C15.2764 16.2336 14.7149 16.6128 14.0704 16.8927C13.4258 17.1726 12.7363 17.3125 12.0018 17.3125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5441_6844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleclockOrange);
export default __webpack_public_path__ + "static/media/scheduleclock_orange.effb482cba9ef11d2f705906d22f568b.svg";
export { ForwardRef as ReactComponent };